import HomePage from "../pages/HomePage";
import RecordPage from "../pages/RecordPage";
import Login from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import Reset from "../pages/ResetPage";
import AccountSettings from "../pages/AccountSettings";
import ReviewPage from "../pages/ReviewPage";
import StatsPage from "../pages/StatsPage";

const routes = [
  {
    path: "/",
    element: <HomePage />,
    private: false
  },
  {
    path: "/register",
    element: <RegisterPage />,
    private: false
  },
  {
    path: "/login",
    element: <Login />,
    private: false
  },
  {
    path: "/reset",
    element: <Reset />,
    private: false
  },
  {
    path: "/record",
    element: <RecordPage />,
    private: true
  },
  {
    path: "/settings",
    element: <AccountSettings />,
    private: true
  },
  {
    path: "/review",
    element: <ReviewPage />,
    private: true
  },
  {
    path: "/stats",
    element: <StatsPage />,
    private: true
  }
];

export default routes;
